import { connect } from 'react-redux';

import SideBar from './SideBar';

const mapStateToProps = (state) => ({
	user: state.googleUser,
});

export default connect(mapStateToProps)(SideBar);
